import { faAngleRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage } from 'react-intl'
import * as HeaderNavigationSubMenuIndexLinkStyles from '../../../../../styles/foundation/HeaderNavigationSubMenuIndexLink.css'
import { formattedMessageValues } from '../../../../../utils/FormattedMessageValues'
import { LocalizedLink } from '../../../../ui/v2/LocalizedLink'

type HeaderNavigationSubMenuIndexLinkProps = {
  href: string
}

export const HeaderNavigationSubMenuIndexLink = ({ href }: HeaderNavigationSubMenuIndexLinkProps) => {
  return (
    <LocalizedLink
      to={href}
      {...(/https/.test(href) && { target: '_blank' })}
      rel="noopener"
      className={HeaderNavigationSubMenuIndexLinkStyles.Container}
    >
      <FormattedMessage
        id="components.foundation.header.nav.subMenu.linkText"
        defaultMessage="一覧を見る"
        values={{ ...formattedMessageValues }}
      />
      <FontAwesomeIcon icon={faAngleRight} width="8" />
    </LocalizedLink>
  )
}
